export class StatDto {
    id: string;
    num: number;

    constructor(id: string, num: number = 1) {
        this.id = id;
        this.num = num;
    }
}
